/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechPhoneSmartIcon16Light } from './TechPhoneSmartIcon16Light';
import { TechPhoneSmartIcon16Regular } from './TechPhoneSmartIcon16Regular';
import { TechPhoneSmartIcon16Solid } from './TechPhoneSmartIcon16Solid';
import { TechPhoneSmartIcon20Light } from './TechPhoneSmartIcon20Light';
import { TechPhoneSmartIcon20Regular } from './TechPhoneSmartIcon20Regular';
import { TechPhoneSmartIcon20Solid } from './TechPhoneSmartIcon20Solid';
import { TechPhoneSmartIcon24Regular } from './TechPhoneSmartIcon24Regular';
import { TechPhoneSmartIcon24Solid } from './TechPhoneSmartIcon24Solid';
import { TechPhoneSmartIcon32Regular } from './TechPhoneSmartIcon32Regular';
import { TechPhoneSmartIcon64Regular } from './TechPhoneSmartIcon64Regular';
var sizes = {
    16: {
        light: TechPhoneSmartIcon16Light,
        regular: TechPhoneSmartIcon16Regular,
        solid: TechPhoneSmartIcon16Solid,
    },
    20: {
        light: TechPhoneSmartIcon20Light,
        regular: TechPhoneSmartIcon20Regular,
        solid: TechPhoneSmartIcon20Solid,
    },
    24: {
        regular: TechPhoneSmartIcon24Regular,
        solid: TechPhoneSmartIcon24Solid,
    },
    32: {
        regular: TechPhoneSmartIcon32Regular,
    },
    64: {
        regular: TechPhoneSmartIcon64Regular,
    },
};
export var TechPhoneSmartIcon = forwardRef('TechPhoneSmartIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
